// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Lazy = require("bs-platform/lib/js/lazy.js");
var List = require("bs-platform/lib/js/list.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Stack = require("bs-platform/lib/js/stack.js");
var $$Buffer = require("bs-platform/lib/js/buffer.js");
var Format = require("bs-platform/lib/js/format.js");
var Printf = require("bs-platform/lib/js/printf.js");
var $$String = require("bs-platform/lib/js/string.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Caml_exceptions = require("bs-platform/lib/js/caml_exceptions.js");
var CamlinternalLazy = require("bs-platform/lib/js/camlinternalLazy.js");

function silent(_fmt, param) {
  return /* () */0;
}

function $$return(fmt_str, out, param) {
  return Curry._1(Format.fprintf(out, /* Format */[
                  /* Format_subst */Block.__(14, [
                      undefined,
                      /* End_of_fmtty */0,
                      /* End_of_format */0
                    ]),
                  "%(%)"
                ]), fmt_str);
}

function unit(fmt, param) {
  return Format.pp_print_string(fmt, "()");
}

function $$int(fmt, i) {
  return Format.pp_print_string(fmt, String(i));
}

function float3(fmt, f) {
  return Curry._1(Format.fprintf(fmt, /* Format */[
                  /* Float */Block.__(8, [
                      /* Float_f */0,
                      /* No_padding */0,
                      /* Lit_precision */[3],
                      /* End_of_format */0
                    ]),
                  "%.3f"
                ]), f);
}

function $$float(fmt, f) {
  return Format.pp_print_string(fmt, Pervasives.string_of_float(f));
}

function int32(fmt, n) {
  return Curry._1(Format.fprintf(fmt, /* Format */[
                  /* Int32 */Block.__(5, [
                      /* Int_d */0,
                      /* No_padding */0,
                      /* No_precision */0,
                      /* End_of_format */0
                    ]),
                  "%ld"
                ]), n);
}

function int64(fmt, n) {
  return Curry._1(Format.fprintf(fmt, /* Format */[
                  /* Int64 */Block.__(7, [
                      /* Int_d */0,
                      /* No_padding */0,
                      /* No_precision */0,
                      /* End_of_format */0
                    ]),
                  "%Ld"
                ]), n);
}

function nativeint(fmt, n) {
  return Curry._1(Format.fprintf(fmt, /* Format */[
                  /* Nativeint */Block.__(6, [
                      /* Int_d */0,
                      /* No_padding */0,
                      /* No_precision */0,
                      /* End_of_format */0
                    ]),
                  "%nd"
                ]), n);
}

function string_quoted(fmt, s) {
  return Curry._1(Format.fprintf(fmt, /* Format */[
                  /* Char_literal */Block.__(12, [
                      /* "\"" */34,
                      /* String */Block.__(2, [
                          /* No_padding */0,
                          /* Char_literal */Block.__(12, [
                              /* "\"" */34,
                              /* End_of_format */0
                            ])
                        ])
                    ]),
                  "\"%s\""
                ]), s);
}

function substring(out, param) {
  return Format.pp_print_string(out, $$String.sub(param[0], param[1], param[2]));
}

function list($staropt$star, pp, fmt, l) {
  var sep;
  if ($staropt$star !== undefined) {
    sep = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* Char_literal */Block.__(12, [
          /* "," */44,
          /* Formatting_lit */Block.__(17, [
              /* Break */Block.__(0, [
                  "@ ",
                  1,
                  0
                ]),
              /* End_of_format */0
            ])
        ]),
      ",@ "
    ];
    sep = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  var _l = l;
  while(true) {
    var l$1 = _l;
    if (l$1) {
      var l$2 = l$1[1];
      var x = l$1[0];
      if (l$2) {
        Curry._2(pp, fmt, x);
        Curry._2(sep, fmt, /* () */0);
        _l = l$2;
        continue ;
      } else {
        return Curry._2(pp, fmt, x);
      }
    } else {
      return /* () */0;
    }
  };
}

function array($staropt$star, pp, fmt, a) {
  var sep;
  if ($staropt$star !== undefined) {
    sep = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* Char_literal */Block.__(12, [
          /* "," */44,
          /* Formatting_lit */Block.__(17, [
              /* Break */Block.__(0, [
                  "@ ",
                  1,
                  0
                ]),
              /* End_of_format */0
            ])
        ]),
      ",@ "
    ];
    sep = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  for(var i = 0 ,i_finish = a.length - 1 | 0; i <= i_finish; ++i){
    if (i > 0) {
      Curry._2(sep, fmt, /* () */0);
    }
    Curry._2(pp, fmt, Caml_array.caml_array_get(a, i));
  }
  return /* () */0;
}

function arrayi($staropt$star, pp, fmt, a) {
  var sep;
  if ($staropt$star !== undefined) {
    sep = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* Char_literal */Block.__(12, [
          /* "," */44,
          /* Formatting_lit */Block.__(17, [
              /* Break */Block.__(0, [
                  "@ ",
                  1,
                  0
                ]),
              /* End_of_format */0
            ])
        ]),
      ",@ "
    ];
    sep = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  for(var i = 0 ,i_finish = a.length - 1 | 0; i <= i_finish; ++i){
    if (i > 0) {
      Curry._2(sep, fmt, /* () */0);
    }
    Curry._2(pp, fmt, /* tuple */[
          i,
          Caml_array.caml_array_get(a, i)
        ]);
  }
  return /* () */0;
}

function seq($staropt$star, pp, fmt, seq$1) {
  var sep;
  if ($staropt$star !== undefined) {
    sep = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* Char_literal */Block.__(12, [
          /* "," */44,
          /* Formatting_lit */Block.__(17, [
              /* Break */Block.__(0, [
                  "@ ",
                  1,
                  0
                ]),
              /* End_of_format */0
            ])
        ]),
      ",@ "
    ];
    sep = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  var first = {
    contents: true
  };
  return Curry._1(seq$1, (function (x) {
                if (first.contents) {
                  first.contents = false;
                } else {
                  Curry._2(sep, fmt, /* () */0);
                }
                return Curry._2(pp, fmt, x);
              }));
}

function opt(pp, fmt, x) {
  if (x !== undefined) {
    return Curry._2(Format.fprintf(fmt, /* Format */[
                    /* String_literal */Block.__(11, [
                        "some ",
                        /* Alpha */Block.__(15, [/* End_of_format */0])
                      ]),
                    "some %a"
                  ]), pp, Caml_option.valFromOption(x));
  } else {
    return Format.pp_print_string(fmt, "none");
  }
}

function pair($staropt$star, ppa, ppb, fmt, param) {
  var sep;
  if ($staropt$star !== undefined) {
    sep = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* Char_literal */Block.__(12, [
          /* "," */44,
          /* Formatting_lit */Block.__(17, [
              /* Break */Block.__(0, [
                  "@ ",
                  1,
                  0
                ]),
              /* End_of_format */0
            ])
        ]),
      ",@ "
    ];
    sep = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  return Curry._6(Format.fprintf(fmt, /* Format */[
                  /* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* End_of_format */0])])]),
                  "%a%a%a"
                ]), ppa, param[0], sep, /* () */0, ppb, param[1]);
}

function triple($staropt$star, ppa, ppb, ppc, fmt, param) {
  var sep;
  if ($staropt$star !== undefined) {
    sep = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* Char_literal */Block.__(12, [
          /* "," */44,
          /* Formatting_lit */Block.__(17, [
              /* Break */Block.__(0, [
                  "@ ",
                  1,
                  0
                ]),
              /* End_of_format */0
            ])
        ]),
      ",@ "
    ];
    sep = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  return Curry.app(Format.fprintf(fmt, /* Format */[
                  /* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* End_of_format */0])])])])]),
                  "%a%a%a%a%a"
                ]), [
              ppa,
              param[0],
              sep,
              /* () */0,
              ppb,
              param[1],
              sep,
              /* () */0,
              ppc,
              param[2]
            ]);
}

function quad($staropt$star, ppa, ppb, ppc, ppd, fmt, param) {
  var sep;
  if ($staropt$star !== undefined) {
    sep = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* Char_literal */Block.__(12, [
          /* "," */44,
          /* Formatting_lit */Block.__(17, [
              /* Break */Block.__(0, [
                  "@ ",
                  1,
                  0
                ]),
              /* End_of_format */0
            ])
        ]),
      ",@ "
    ];
    sep = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  return Curry.app(Format.fprintf(fmt, /* Format */[
                  /* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* End_of_format */0])])])])])])]),
                  "%a%a%a%a%a%a%a"
                ]), [
              ppa,
              param[0],
              sep,
              /* () */0,
              ppb,
              param[1],
              sep,
              /* () */0,
              ppc,
              param[2],
              sep,
              /* () */0,
              ppd,
              param[3]
            ]);
}

function within(a, b, p, out, x) {
  Format.pp_print_string(out, a);
  Curry._2(p, out, x);
  return Format.pp_print_string(out, b);
}

function map(f, pp, fmt, x) {
  Curry._2(pp, fmt, Curry._1(f, x));
  return /* () */0;
}

function vbox($staropt$star, pp, out, x) {
  var i = $staropt$star !== undefined ? $staropt$star : 0;
  Format.pp_open_vbox(out, i);
  Curry._2(pp, out, x);
  return Format.pp_close_box(out, /* () */0);
}

function hovbox($staropt$star, pp, out, x) {
  var i = $staropt$star !== undefined ? $staropt$star : 0;
  Format.pp_open_hovbox(out, i);
  Curry._2(pp, out, x);
  return Format.pp_close_box(out, /* () */0);
}

function hvbox($staropt$star, pp, out, x) {
  var i = $staropt$star !== undefined ? $staropt$star : 0;
  Format.pp_open_hvbox(out, i);
  Curry._2(pp, out, x);
  return Format.pp_close_box(out, /* () */0);
}

function hbox(pp, out, x) {
  Format.pp_open_hbox(out, /* () */0);
  Curry._2(pp, out, x);
  return Format.pp_close_box(out, /* () */0);
}

function of_to_string(f, out, x) {
  return Format.pp_print_string(out, Curry._1(f, x));
}

function $$const(pp, x, out, param) {
  return Curry._2(pp, out, x);
}

function some(pp, out, param) {
  if (param !== undefined) {
    return Curry._2(pp, out, Caml_option.valFromOption(param));
  } else {
    return /* () */0;
  }
}

function lazy_force(pp, out, param) {
  var x = CamlinternalLazy.force(param);
  return Curry._2(pp, out, x);
}

function lazy_or($staropt$star, pp, out, x) {
  var $$default;
  if ($staropt$star !== undefined) {
    $$default = $staropt$star;
  } else {
    var partial_arg = /* Format */[
      /* String_literal */Block.__(11, [
          "<lazy>",
          /* End_of_format */0
        ]),
      "<lazy>"
    ];
    $$default = (function (param, param$1) {
        return $$return(partial_arg, param, param$1);
      });
  }
  if (Lazy.is_val(x)) {
    return Curry._2(pp, out, CamlinternalLazy.force(x));
  } else {
    return Curry._2($$default, out, /* () */0);
  }
}

function output(fmt, pp, x) {
  return Curry._2(pp, fmt, x);
}

function to_string(pp, x) {
  var buf = $$Buffer.create(64);
  var fmt = Format.formatter_of_buffer(buf);
  Curry._2(pp, fmt, x);
  Format.pp_print_flush(fmt, /* () */0);
  return $$Buffer.contents(buf);
}

function with_out_chan(oc, f) {
  var fmt = Format.formatter_of_out_channel(oc);
  try {
    var x = Curry._1(f, fmt);
    Format.pp_print_flush(fmt, /* () */0);
    return x;
  }
  catch (e){
    Format.pp_print_flush(fmt, /* () */0);
    throw e;
  }
}

function tee(a, b) {
  var fa = Format.pp_get_formatter_out_functions(a, /* () */0);
  var fb = Format.pp_get_formatter_out_functions(b, /* () */0);
  return Format.make_formatter((function (str, i, len) {
                Curry._3(fa.out_string, str, i, len);
                return Curry._3(fb.out_string, str, i, len);
              }), (function (param) {
                Curry._1(fa.out_flush, /* () */0);
                return Curry._1(fb.out_flush, /* () */0);
              }));
}

function to_file(filename, format) {
  var oc = Pervasives.open_out(filename);
  var fmt = Format.formatter_of_out_channel(oc);
  return Format.kfprintf((function (fmt) {
                Format.pp_print_flush(fmt, /* () */0);
                return Pervasives.close_out_noerr(oc);
              }), fmt, format);
}

function int_of_color_(param) {
  if (param >= 82908052) {
    if (param >= 749039939) {
      if (param >= 756711075) {
        return 2;
      } else {
        return 6;
      }
    } else if (param >= 737308346) {
      return 4;
    } else {
      return 3;
    }
  } else if (param >= -588596599) {
    if (param >= 4100401) {
      return 1;
    } else {
      return 7;
    }
  } else if (param >= -605101559) {
    return 5;
  } else {
    return 0;
  }
}

function code_of_style(param) {
  if (typeof param === "number") {
    if (param >= 737455525) {
      return 1;
    } else {
      return 0;
    }
  } else if (param[0] >= 15681) {
    return 30 + int_of_color_(param[1]) | 0;
  } else {
    return 40 + int_of_color_(param[1]) | 0;
  }
}

function ansi_l_to_str_(l) {
  if (l) {
    var match = l[1];
    var a = l[0];
    if (match) {
      if (match[1]) {
        var buf = $$Buffer.create(16);
        $$Buffer.add_string(buf, "\x1b[");
        List.iteri((function (i, c) {
                if (i > 0) {
                  $$Buffer.add_char(buf, /* ";" */59);
                }
                var c$1 = c;
                return $$Buffer.add_string(buf, String(code_of_style(c$1)));
              }), l);
        $$Buffer.add_string(buf, "m");
        return $$Buffer.contents(buf);
      } else {
        return Curry._2(Printf.sprintf(/* Format */[
                        /* String_literal */Block.__(11, [
                            "\x1b[",
                            /* Int */Block.__(4, [
                                /* Int_d */0,
                                /* No_padding */0,
                                /* No_precision */0,
                                /* Char_literal */Block.__(12, [
                                    /* ";" */59,
                                    /* Int */Block.__(4, [
                                        /* Int_d */0,
                                        /* No_padding */0,
                                        /* No_precision */0,
                                        /* Char_literal */Block.__(12, [
                                            /* "m" */109,
                                            /* End_of_format */0
                                          ])
                                      ])
                                  ])
                              ])
                          ]),
                        "\x1b[%d;%dm"
                      ]), code_of_style(a), code_of_style(match[0]));
      }
    } else {
      return Curry._1(Printf.sprintf(/* Format */[
                      /* String_literal */Block.__(11, [
                          "\x1b[",
                          /* Int */Block.__(4, [
                              /* Int_d */0,
                              /* No_padding */0,
                              /* No_precision */0,
                              /* Char_literal */Block.__(12, [
                                  /* "m" */109,
                                  /* End_of_format */0
                                ])
                            ])
                        ]),
                      "\x1b[%dm"
                    ]), code_of_style(a));
    }
  } else {
    return "\x1b[0m";
  }
}

var No_such_style = Caml_exceptions.create("CCFormat.No_such_style");

function style_of_tag_(s) {
  var match = $$String.trim(s);
  switch (match) {
    case "Black" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Black */-937474657
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "Blue" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Blue */737308346
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "Cyan" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Cyan */749039939
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "Green" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Green */756711075
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "Magenta" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Magenta */-605101559
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "Red" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Red */4100401
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "White" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* White */-588596599
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "Yellow" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Yellow */82908052
                ],
                /* :: */[
                  /* Bold */737455525,
                  /* [] */0
                ]
              ];
    case "black" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Black */-937474657
                ],
                /* [] */0
              ];
    case "blue" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Blue */737308346
                ],
                /* [] */0
              ];
    case "bold" :
        return /* :: */[
                /* Bold */737455525,
                /* [] */0
              ];
    case "cyan" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Cyan */749039939
                ],
                /* [] */0
              ];
    case "green" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Green */756711075
                ],
                /* [] */0
              ];
    case "magenta" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Magenta */-605101559
                ],
                /* [] */0
              ];
    case "red" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Red */4100401
                ],
                /* [] */0
              ];
    case "reset" :
        return /* :: */[
                /* Reset */-101336657,
                /* [] */0
              ];
    case "white" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* White */-588596599
                ],
                /* [] */0
              ];
    case "yellow" :
        return /* :: */[
                /* `FG */[
                  15681,
                  /* Yellow */82908052
                ],
                /* [] */0
              ];
    default:
      throw No_such_style;
  }
}

var color_enabled = {
  contents: false
};

function set_color_tag_handling(ppf) {
  var functions = Format.pp_get_formatter_tag_functions(ppf, /* () */0);
  var st = Stack.create(/* () */0);
  var partial_arg = functions.mark_open_tag;
  var partial_arg$1 = functions.mark_close_tag;
  var functions$prime_mark_open_tag = function (param) {
    var st$1 = st;
    var or_else = partial_arg;
    var s = param;
    try {
      var style = style_of_tag_(s);
      Stack.push(style, st$1);
      if (color_enabled.contents) {
        return ansi_l_to_str_(style);
      } else {
        return "";
      }
    }
    catch (exn){
      if (exn === No_such_style) {
        return Curry._1(or_else, s);
      } else {
        throw exn;
      }
    }
  };
  var functions$prime_mark_close_tag = function (param) {
    var st$1 = st;
    var or_else = partial_arg$1;
    var s = param;
    var val;
    try {
      val = style_of_tag_(s);
    }
    catch (exn){
      if (exn === No_such_style) {
        return Curry._1(or_else, s);
      } else {
        throw exn;
      }
    }
    var style;
    try {
      Stack.pop(st$1);
      style = Stack.top(st$1);
    }
    catch (exn$1){
      if (exn$1 === Stack.Empty) {
        style = /* :: */[
          /* Reset */-101336657,
          /* [] */0
        ];
      } else {
        throw exn$1;
      }
    }
    if (color_enabled.contents) {
      return ansi_l_to_str_(style);
    } else {
      return "";
    }
  };
  var functions$prime_print_open_tag = functions.print_open_tag;
  var functions$prime_print_close_tag = functions.print_close_tag;
  var functions$prime = {
    mark_open_tag: functions$prime_mark_open_tag,
    mark_close_tag: functions$prime_mark_close_tag,
    print_open_tag: functions$prime_print_open_tag,
    print_close_tag: functions$prime_print_close_tag
  };
  Format.pp_set_mark_tags(ppf, true);
  return Format.pp_set_formatter_tag_functions(ppf, functions$prime);
}

var first = {
  contents: true
};

function set_color_default(b) {
  if (b && !color_enabled.contents) {
    color_enabled.contents = true;
    if (first.contents) {
      first.contents = false;
      set_color_tag_handling(Format.std_formatter);
      return set_color_tag_handling(Format.err_formatter);
    } else {
      return 0;
    }
  } else if (!b && color_enabled.contents) {
    color_enabled.contents = false;
    return /* () */0;
  } else {
    return 0;
  }
}

function with_color(s, pp, out, x) {
  Format.pp_open_tag(out, s);
  Curry._2(pp, out, x);
  return Format.pp_close_tag(out, /* () */0);
}

function with_colorf(s, out, fmt) {
  Format.pp_open_tag(out, s);
  return Format.kfprintf((function (out) {
                return Format.pp_close_tag(out, /* () */0);
              }), out, fmt);
}

function sprintf_(c, format) {
  var buf = $$Buffer.create(64);
  var fmt = Format.formatter_of_buffer(buf);
  if (c && color_enabled.contents) {
    set_color_tag_handling(fmt);
  }
  return Format.kfprintf((function (_fmt) {
                Format.pp_print_flush(fmt, /* () */0);
                return $$Buffer.contents(buf);
              }), fmt, format);
}

function with_color_ksf(f, s, fmt) {
  var buf = $$Buffer.create(64);
  var out = Format.formatter_of_buffer(buf);
  if (color_enabled.contents) {
    set_color_tag_handling(out);
  }
  Format.pp_open_tag(out, s);
  return Format.kfprintf((function (out) {
                Format.pp_close_tag(out, /* () */0);
                Format.pp_print_flush(out, /* () */0);
                return Curry._1(f, $$Buffer.contents(buf));
              }), out, fmt);
}

function with_color_sf(s, fmt) {
  return with_color_ksf((function (s) {
                return s;
              }), s, fmt);
}

function sprintf(fmt) {
  return sprintf_(true, fmt);
}

function sprintf_no_color(fmt) {
  return sprintf_(false, fmt);
}

var sprintf_dyn_color = sprintf_;

function fprintf_dyn_color(colors, out, fmt) {
  var old_tags = Format.pp_get_mark_tags(out, /* () */0);
  Format.pp_set_mark_tags(out, colors);
  return Format.kfprintf((function (out) {
                return Format.pp_set_mark_tags(out, old_tags);
              }), out, fmt);
}

function ksprintf(margin, f, fmt) {
  var buf = $$Buffer.create(32);
  var out = Format.formatter_of_buffer(buf);
  if (color_enabled.contents) {
    set_color_tag_handling(out);
  }
  if (margin !== undefined) {
    Format.pp_set_margin(out, margin);
  }
  return Format.kfprintf((function (param) {
                Format.pp_print_flush(out, /* () */0);
                return Curry._1(f, $$Buffer.contents(buf));
              }), out, fmt);
}

function list$1(pp) {
  var partial_arg = /* Format */[
    /* Char_literal */Block.__(12, [
        /* ";" */59,
        /* Formatting_lit */Block.__(17, [
            /* Break */Block.__(0, [
                "@,",
                0,
                0
              ]),
            /* End_of_format */0
          ])
      ]),
    ";@,"
  ];
  var partial_arg$1 = (function (param, param$1) {
      return $$return(partial_arg, param, param$1);
    });
  var partial_arg$2 = function (param, param$1) {
    return list(partial_arg$1, pp, param, param$1);
  };
  var partial_arg$3 = function (param, param$1) {
    return hovbox(undefined, partial_arg$2, param, param$1);
  };
  return (function (param, param$1) {
      return within("[", "]", partial_arg$3, param, param$1);
    });
}

function array$1(pp) {
  var partial_arg = /* Format */[
    /* Char_literal */Block.__(12, [
        /* ";" */59,
        /* Formatting_lit */Block.__(17, [
            /* Break */Block.__(0, [
                "@,",
                0,
                0
              ]),
            /* End_of_format */0
          ])
      ]),
    ";@,"
  ];
  var partial_arg$1 = (function (param, param$1) {
      return $$return(partial_arg, param, param$1);
    });
  var partial_arg$2 = function (param, param$1) {
    return array(partial_arg$1, pp, param, param$1);
  };
  var partial_arg$3 = function (param, param$1) {
    return hovbox(undefined, partial_arg$2, param, param$1);
  };
  return (function (param, param$1) {
      return within("[|", "|]", partial_arg$3, param, param$1);
    });
}

function option(pp, out, x) {
  if (x !== undefined) {
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* String_literal */Block.__(11, [
                        "Some ",
                        /* Alpha */Block.__(15, [/* End_of_format */0])
                      ]),
                    "Some %a"
                  ]), pp, Caml_option.valFromOption(x));
  } else {
    return Format.pp_print_string(out, "None");
  }
}

function pair$1(p1, p2) {
  return (function (param, param$1) {
      return within("(", ")", (function (param, param$1) {
                    return hovbox(undefined, (function (param, param$1) {
                                  return pair(undefined, p1, p2, param, param$1);
                                }), param, param$1);
                  }), param, param$1);
    });
}

function triple$1(p1, p2, p3) {
  return (function (param, param$1) {
      return within("(", ")", (function (param, param$1) {
                    return hovbox(undefined, (function (param, param$1) {
                                  return triple(undefined, p1, p2, p3, param, param$1);
                                }), param, param$1);
                  }), param, param$1);
    });
}

function quad$1(p1, p2, p3, p4) {
  return (function (param, param$1) {
      return within("(", ")", (function (param, param$1) {
                    return hovbox(undefined, (function (param, param$1) {
                                  return quad(undefined, p1, p2, p3, p4, param, param$1);
                                }), param, param$1);
                  }), param, param$1);
    });
}

function result$prime(pok, perror, out, param) {
  if (param.tag) {
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* Char_literal */Block.__(12, [
                        /* "(" */40,
                        /* Formatting_gen */Block.__(18, [
                            /* Open_box */Block.__(1, [/* Format */[
                                  /* End_of_format */0,
                                  ""
                                ]]),
                            /* String_literal */Block.__(11, [
                                "Error ",
                                /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                        /* Close_box */0,
                                        /* Char_literal */Block.__(12, [
                                            /* ")" */41,
                                            /* End_of_format */0
                                          ])
                                      ])])
                              ])
                          ])
                      ]),
                    "(@[Error %a@])"
                  ]), perror, param[0]);
  } else {
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* Char_literal */Block.__(12, [
                        /* "(" */40,
                        /* Formatting_gen */Block.__(18, [
                            /* Open_box */Block.__(1, [/* Format */[
                                  /* End_of_format */0,
                                  ""
                                ]]),
                            /* String_literal */Block.__(11, [
                                "Ok ",
                                /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                        /* Close_box */0,
                                        /* Char_literal */Block.__(12, [
                                            /* ")" */41,
                                            /* End_of_format */0
                                          ])
                                      ])])
                              ])
                          ])
                      ]),
                    "(@[Ok %a@])"
                  ]), pok, param[0]);
  }
}

function result(pok) {
  return (function (param, param$1) {
      return result$prime(pok, string_quoted, param, param$1);
    });
}

var pp_open_box = Format.pp_open_box;

var open_box = Format.open_box;

var pp_close_box = Format.pp_close_box;

var close_box = Format.close_box;

var pp_open_hbox = Format.pp_open_hbox;

var open_hbox = Format.open_hbox;

var pp_open_vbox = Format.pp_open_vbox;

var open_vbox = Format.open_vbox;

var pp_open_hvbox = Format.pp_open_hvbox;

var open_hvbox = Format.open_hvbox;

var pp_open_hovbox = Format.pp_open_hovbox;

var open_hovbox = Format.open_hovbox;

var pp_print_string = Format.pp_print_string;

var print_string = Format.print_string;

var pp_print_as = Format.pp_print_as;

var print_as = Format.print_as;

var pp_print_int = Format.pp_print_int;

var print_int = Format.print_int;

var pp_print_float = Format.pp_print_float;

var print_float = Format.print_float;

var pp_print_char = Format.pp_print_char;

var print_char = Format.print_char;

var pp_print_bool = Format.pp_print_bool;

var print_bool = Format.print_bool;

var pp_print_space = Format.pp_print_space;

var print_space = Format.print_space;

var pp_print_cut = Format.pp_print_cut;

var print_cut = Format.print_cut;

var pp_print_break = Format.pp_print_break;

var print_break = Format.print_break;

var pp_force_newline = Format.pp_force_newline;

var force_newline = Format.force_newline;

var pp_print_if_newline = Format.pp_print_if_newline;

var print_if_newline = Format.print_if_newline;

var pp_print_flush = Format.pp_print_flush;

var print_flush = Format.print_flush;

var pp_print_newline = Format.pp_print_newline;

var print_newline = Format.print_newline;

var pp_set_margin = Format.pp_set_margin;

var set_margin = Format.set_margin;

var pp_get_margin = Format.pp_get_margin;

var get_margin = Format.get_margin;

var pp_set_max_indent = Format.pp_set_max_indent;

var set_max_indent = Format.set_max_indent;

var pp_get_max_indent = Format.pp_get_max_indent;

var get_max_indent = Format.get_max_indent;

var pp_set_max_boxes = Format.pp_set_max_boxes;

var set_max_boxes = Format.set_max_boxes;

var pp_get_max_boxes = Format.pp_get_max_boxes;

var get_max_boxes = Format.get_max_boxes;

var pp_over_max_boxes = Format.pp_over_max_boxes;

var over_max_boxes = Format.over_max_boxes;

var pp_open_tbox = Format.pp_open_tbox;

var open_tbox = Format.open_tbox;

var pp_close_tbox = Format.pp_close_tbox;

var close_tbox = Format.close_tbox;

var pp_set_tab = Format.pp_set_tab;

var set_tab = Format.set_tab;

var pp_print_tab = Format.pp_print_tab;

var print_tab = Format.print_tab;

var pp_print_tbreak = Format.pp_print_tbreak;

var print_tbreak = Format.print_tbreak;

var pp_set_ellipsis_text = Format.pp_set_ellipsis_text;

var set_ellipsis_text = Format.set_ellipsis_text;

var pp_get_ellipsis_text = Format.pp_get_ellipsis_text;

var get_ellipsis_text = Format.get_ellipsis_text;

var pp_open_tag = Format.pp_open_tag;

var open_tag = Format.open_tag;

var pp_close_tag = Format.pp_close_tag;

var close_tag = Format.close_tag;

var pp_set_tags = Format.pp_set_tags;

var set_tags = Format.set_tags;

var pp_set_print_tags = Format.pp_set_print_tags;

var set_print_tags = Format.set_print_tags;

var pp_set_mark_tags = Format.pp_set_mark_tags;

var set_mark_tags = Format.set_mark_tags;

var pp_get_print_tags = Format.pp_get_print_tags;

var get_print_tags = Format.get_print_tags;

var pp_get_mark_tags = Format.pp_get_mark_tags;

var get_mark_tags = Format.get_mark_tags;

var pp_set_formatter_out_channel = Format.pp_set_formatter_out_channel;

var set_formatter_out_channel = Format.set_formatter_out_channel;

var pp_set_formatter_output_functions = Format.pp_set_formatter_output_functions;

var set_formatter_output_functions = Format.set_formatter_output_functions;

var pp_get_formatter_output_functions = Format.pp_get_formatter_output_functions;

var get_formatter_output_functions = Format.get_formatter_output_functions;

var pp_set_formatter_out_functions = Format.pp_set_formatter_out_functions;

var set_formatter_out_functions = Format.set_formatter_out_functions;

var pp_get_formatter_out_functions = Format.pp_get_formatter_out_functions;

var get_formatter_out_functions = Format.get_formatter_out_functions;

var pp_set_formatter_tag_functions = Format.pp_set_formatter_tag_functions;

var set_formatter_tag_functions = Format.set_formatter_tag_functions;

var pp_get_formatter_tag_functions = Format.pp_get_formatter_tag_functions;

var get_formatter_tag_functions = Format.get_formatter_tag_functions;

var formatter_of_out_channel = Format.formatter_of_out_channel;

var std_formatter = Format.std_formatter;

var err_formatter = Format.err_formatter;

var formatter_of_buffer = Format.formatter_of_buffer;

var stdbuf = Format.stdbuf;

var str_formatter = Format.str_formatter;

var flush_str_formatter = Format.flush_str_formatter;

var make_formatter = Format.make_formatter;

var formatter_of_out_functions = Format.formatter_of_out_functions;

var make_symbolic_output_buffer = Format.make_symbolic_output_buffer;

var clear_symbolic_output_buffer = Format.clear_symbolic_output_buffer;

var get_symbolic_output_buffer = Format.get_symbolic_output_buffer;

var flush_symbolic_output_buffer = Format.flush_symbolic_output_buffer;

var add_symbolic_output_item = Format.add_symbolic_output_item;

var formatter_of_symbolic_output_buffer = Format.formatter_of_symbolic_output_buffer;

var pp_print_list = Format.pp_print_list;

var pp_print_text = Format.pp_print_text;

var printf = Format.printf;

var eprintf = Format.eprintf;

var asprintf = Format.asprintf;

var ifprintf = Format.ifprintf;

var kfprintf = Format.kfprintf;

var ikfprintf = Format.ikfprintf;

var kasprintf = Format.kasprintf;

var bprintf = Format.bprintf;

var kprintf = Format.kprintf;

var set_all_formatter_output_functions = Format.set_all_formatter_output_functions;

var get_all_formatter_output_functions = Format.get_all_formatter_output_functions;

var pp_set_all_formatter_output_functions = Format.pp_set_all_formatter_output_functions;

var pp_get_all_formatter_output_functions = Format.pp_get_all_formatter_output_functions;

var string = Format.pp_print_string;

var bool = Format.pp_print_bool;

var newline = Format.pp_force_newline;

var text = Format.pp_print_text;

var $$char = Format.pp_print_char;

var flush = Format.pp_print_flush;

var of_chan = Format.formatter_of_out_channel;

var stdout = Format.std_formatter;

var stderr = Format.err_formatter;

var fprintf = Format.fprintf;

var Dump = {
  unit: unit,
  $$int: $$int,
  string: string_quoted,
  bool: Format.pp_print_bool,
  $$float: $$float,
  $$char: Format.pp_print_char,
  int32: int32,
  int64: int64,
  nativeint: nativeint,
  list: list$1,
  array: array$1,
  option: option,
  pair: pair$1,
  triple: triple$1,
  quad: quad$1,
  result: result,
  result$prime: result$prime,
  to_string: to_string
};

exports.pp_open_box = pp_open_box;
exports.open_box = open_box;
exports.pp_close_box = pp_close_box;
exports.close_box = close_box;
exports.pp_open_hbox = pp_open_hbox;
exports.open_hbox = open_hbox;
exports.pp_open_vbox = pp_open_vbox;
exports.open_vbox = open_vbox;
exports.pp_open_hvbox = pp_open_hvbox;
exports.open_hvbox = open_hvbox;
exports.pp_open_hovbox = pp_open_hovbox;
exports.open_hovbox = open_hovbox;
exports.pp_print_string = pp_print_string;
exports.print_string = print_string;
exports.pp_print_as = pp_print_as;
exports.print_as = print_as;
exports.pp_print_int = pp_print_int;
exports.print_int = print_int;
exports.pp_print_float = pp_print_float;
exports.print_float = print_float;
exports.pp_print_char = pp_print_char;
exports.print_char = print_char;
exports.pp_print_bool = pp_print_bool;
exports.print_bool = print_bool;
exports.pp_print_space = pp_print_space;
exports.print_space = print_space;
exports.pp_print_cut = pp_print_cut;
exports.print_cut = print_cut;
exports.pp_print_break = pp_print_break;
exports.print_break = print_break;
exports.pp_force_newline = pp_force_newline;
exports.force_newline = force_newline;
exports.pp_print_if_newline = pp_print_if_newline;
exports.print_if_newline = print_if_newline;
exports.pp_print_flush = pp_print_flush;
exports.print_flush = print_flush;
exports.pp_print_newline = pp_print_newline;
exports.print_newline = print_newline;
exports.pp_set_margin = pp_set_margin;
exports.set_margin = set_margin;
exports.pp_get_margin = pp_get_margin;
exports.get_margin = get_margin;
exports.pp_set_max_indent = pp_set_max_indent;
exports.set_max_indent = set_max_indent;
exports.pp_get_max_indent = pp_get_max_indent;
exports.get_max_indent = get_max_indent;
exports.pp_set_max_boxes = pp_set_max_boxes;
exports.set_max_boxes = set_max_boxes;
exports.pp_get_max_boxes = pp_get_max_boxes;
exports.get_max_boxes = get_max_boxes;
exports.pp_over_max_boxes = pp_over_max_boxes;
exports.over_max_boxes = over_max_boxes;
exports.pp_open_tbox = pp_open_tbox;
exports.open_tbox = open_tbox;
exports.pp_close_tbox = pp_close_tbox;
exports.close_tbox = close_tbox;
exports.pp_set_tab = pp_set_tab;
exports.set_tab = set_tab;
exports.pp_print_tab = pp_print_tab;
exports.print_tab = print_tab;
exports.pp_print_tbreak = pp_print_tbreak;
exports.print_tbreak = print_tbreak;
exports.pp_set_ellipsis_text = pp_set_ellipsis_text;
exports.set_ellipsis_text = set_ellipsis_text;
exports.pp_get_ellipsis_text = pp_get_ellipsis_text;
exports.get_ellipsis_text = get_ellipsis_text;
exports.pp_open_tag = pp_open_tag;
exports.open_tag = open_tag;
exports.pp_close_tag = pp_close_tag;
exports.close_tag = close_tag;
exports.pp_set_tags = pp_set_tags;
exports.set_tags = set_tags;
exports.pp_set_print_tags = pp_set_print_tags;
exports.set_print_tags = set_print_tags;
exports.pp_set_mark_tags = pp_set_mark_tags;
exports.set_mark_tags = set_mark_tags;
exports.pp_get_print_tags = pp_get_print_tags;
exports.get_print_tags = get_print_tags;
exports.pp_get_mark_tags = pp_get_mark_tags;
exports.get_mark_tags = get_mark_tags;
exports.pp_set_formatter_out_channel = pp_set_formatter_out_channel;
exports.set_formatter_out_channel = set_formatter_out_channel;
exports.pp_set_formatter_output_functions = pp_set_formatter_output_functions;
exports.set_formatter_output_functions = set_formatter_output_functions;
exports.pp_get_formatter_output_functions = pp_get_formatter_output_functions;
exports.get_formatter_output_functions = get_formatter_output_functions;
exports.pp_set_formatter_out_functions = pp_set_formatter_out_functions;
exports.set_formatter_out_functions = set_formatter_out_functions;
exports.pp_get_formatter_out_functions = pp_get_formatter_out_functions;
exports.get_formatter_out_functions = get_formatter_out_functions;
exports.pp_set_formatter_tag_functions = pp_set_formatter_tag_functions;
exports.set_formatter_tag_functions = set_formatter_tag_functions;
exports.pp_get_formatter_tag_functions = pp_get_formatter_tag_functions;
exports.get_formatter_tag_functions = get_formatter_tag_functions;
exports.formatter_of_out_channel = formatter_of_out_channel;
exports.std_formatter = std_formatter;
exports.err_formatter = err_formatter;
exports.formatter_of_buffer = formatter_of_buffer;
exports.stdbuf = stdbuf;
exports.str_formatter = str_formatter;
exports.flush_str_formatter = flush_str_formatter;
exports.make_formatter = make_formatter;
exports.formatter_of_out_functions = formatter_of_out_functions;
exports.make_symbolic_output_buffer = make_symbolic_output_buffer;
exports.clear_symbolic_output_buffer = clear_symbolic_output_buffer;
exports.get_symbolic_output_buffer = get_symbolic_output_buffer;
exports.flush_symbolic_output_buffer = flush_symbolic_output_buffer;
exports.add_symbolic_output_item = add_symbolic_output_item;
exports.formatter_of_symbolic_output_buffer = formatter_of_symbolic_output_buffer;
exports.pp_print_list = pp_print_list;
exports.pp_print_text = pp_print_text;
exports.printf = printf;
exports.eprintf = eprintf;
exports.asprintf = asprintf;
exports.ifprintf = ifprintf;
exports.kfprintf = kfprintf;
exports.ikfprintf = ikfprintf;
exports.kasprintf = kasprintf;
exports.bprintf = bprintf;
exports.kprintf = kprintf;
exports.set_all_formatter_output_functions = set_all_formatter_output_functions;
exports.get_all_formatter_output_functions = get_all_formatter_output_functions;
exports.pp_set_all_formatter_output_functions = pp_set_all_formatter_output_functions;
exports.pp_get_all_formatter_output_functions = pp_get_all_formatter_output_functions;
exports.silent = silent;
exports.unit = unit;
exports.$$int = $$int;
exports.string = string;
exports.bool = bool;
exports.float3 = float3;
exports.$$float = $$float;
exports.newline = newline;
exports.substring = substring;
exports.text = text;
exports.$$char = $$char;
exports.int32 = int32;
exports.int64 = int64;
exports.nativeint = nativeint;
exports.flush = flush;
exports.string_quoted = string_quoted;
exports.list = list;
exports.array = array;
exports.arrayi = arrayi;
exports.seq = seq;
exports.opt = opt;
exports.pair = pair;
exports.triple = triple;
exports.quad = quad;
exports.within = within;
exports.map = map;
exports.vbox = vbox;
exports.hvbox = hvbox;
exports.hovbox = hovbox;
exports.hbox = hbox;
exports.$$return = $$return;
exports.of_to_string = of_to_string;
exports.$$const = $$const;
exports.some = some;
exports.lazy_force = lazy_force;
exports.lazy_or = lazy_or;
exports.set_color_tag_handling = set_color_tag_handling;
exports.set_color_default = set_color_default;
exports.with_color = with_color;
exports.with_colorf = with_colorf;
exports.with_color_sf = with_color_sf;
exports.with_color_ksf = with_color_ksf;
exports.output = output;
exports.to_string = to_string;
exports.of_chan = of_chan;
exports.with_out_chan = with_out_chan;
exports.stdout = stdout;
exports.stderr = stderr;
exports.tee = tee;
exports.sprintf = sprintf;
exports.sprintf_no_color = sprintf_no_color;
exports.sprintf_dyn_color = sprintf_dyn_color;
exports.fprintf = fprintf;
exports.fprintf_dyn_color = fprintf_dyn_color;
exports.ksprintf = ksprintf;
exports.to_file = to_file;
exports.Dump = Dump;
/* Format Not a pure module */
